export default __webpack_public_path__ + "static/media/colorIconManufacturer.12aa2d8f.svg";